import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_6fa72c44-1c40-4a4f-af1b-3eb11820d1a2/artifacts/om2zhbmr_logoellawedding-white.png";
const LAURINE_PHOTO = "https://customer-assets.emergentagent.com/job_precision-amour/artifacts/vid4snop_IMG_2975.png";
const HERO_IMG = "https://customer-assets.emergentagent.com/job_precision-amour/artifacts/gdjndt3w__%20%283%29.jpeg";
const SERVICES_IMG = "https://customer-assets.emergentagent.com/job_precision-amour/artifacts/84i9o23r_WhatsApp%20Image%202026-03-19%20at%2015.35.31.jpeg";

const maestra = [
  { letter: "M", name: "Maîtrise", desc: "Chaque détail maîtrisé avec précision. Rien n'est laissé au hasard dans l'orchestration de votre mariage." },
  { letter: "A", name: "Anticipation", desc: "Nous anticipons chaque besoin avant qu'il ne se manifeste, pour une journée vécue en toute sérénité." },
  { letter: "E", name: "Élégance", desc: "L'élégance est notre signature. Chaque choix esthétique reflète votre histoire et votre style unique." },
  { letter: "S", name: "Sérénité", desc: "Votre sérénité est notre priorité absolue. Nous gérons tout pour que vous profitiez pleinement de votre jour J." },
  { letter: "T", name: "Timing", desc: "Le timing parfait, comme une symphonie. Chaque moment orchestré pour créer une harmonie parfaite." },
  { letter: "R", name: "Relation", desc: "Une relation de confiance et d'écoute. Nous sommes votre partenaire tout au long de cette aventure." },
  { letter: "A", name: "Harmonie", desc: "L'harmonie entre vos désirs, votre budget et la réalité — pour le mariage de rêve qui vous ressemble." },
];

const services = [
  {
    num: "01",
    name: "SYMPHONIE",
    type: "Organisation Complète",
    desc: "Pensée pour les couples qui souhaitent déléguer l'intégralité de leur mariage et vivre une célébration élégante, structurée et culturellement maîtrisée.",
  },
  {
    num: "02",
    name: "CADENCE",
    type: "Organisation Partielle",
    desc: "Destinée aux couples ayant déjà avancé et souhaitant sécuriser et harmoniser leur organisation.",
  },
  {
    num: "03",
    name: "APOGÉE",
    type: "Coordination Jour J",
    desc: "Pour les couples ayant organisé leur mariage et souhaitant vivre leur journée sans gestion ni imprévu.",
  },
  {
    num: "04",
    name: "PRÉLUDE",
    type: "Wedding Coaching",
    desc: "Une séance d'accompagnement pour organiser votre mariage avec méthode et sérénité.",
  },
];

const faqs = [
  {
    q: "Comment se déroule le premier contact ?",
    a: "Tout commence par un appel découverte gratuit de 30 minutes. C'est un moment d'échange sans engagement, sans pression. Je vous écoute, vous posez vos questions, on voit ensemble si la collaboration fait sens. Si c'est le cas, je vous envoie une proposition personnalisée sous 48h.",
    cta: { label: "Réserver mon appel découverte", href: "https://calendly.com/ellaa-wedding/30min" },
  },
  {
    q: "Quelle est la différence entre vos formules ?",
    a: "Tout dépend de là où vous en êtes dans votre projet. SYMPHONIE est faite pour les couples qui souhaitent tout déléguer dès le départ. CADENCE intervient si vous avez déjà commencé mais besoin d'un regard expert. APOGÉE est la formule idéale si vous avez tout organisé et souhaitez être pleinement libres le Jour-J. PRÉLUDE s'adresse aux couples autonomes qui veulent avancer avec méthode. En cas de doute, l'appel découverte est là pour vous orienter.",
    cta: null,
  },
  {
    q: "Combien de temps à l'avance faut-il réserver ?",
    a: "Pour une formule SYMPHONIE ou CADENCE, je recommande de me contacter au moins 12 à 18 mois avant votre date, les prestataires haut de gamme et les lieux d'exception se réservent très tôt. Pour une formule APOGÉE, 6 mois minimum sont nécessaires pour une coordination de qualité. Pour PRÉLUDE, vous pouvez me contacter à tout moment de votre préparation.",
    cta: null,
  },
  {
    q: "Intervenez-vous partout en France ?",
    a: "Oui. Je suis basée en France et j'interviens sur l'ensemble du territoire, Paris et Île-de-France, régions, et destinations en France métropolitaine. Chaque projet est étudié selon sa localisation pour vous garantir un réseau de prestataires adapté et une présence sans faille le Jour-J.",
    cta: null,
  },
  {
    q: "Organisez-vous des mariages à l'étranger ?",
    a: "Oui, pour des projets d'exception. Je peux intervenir en Europe et dans les DOM-TOM, Guadeloupe, Martinique, La Réunion, Mayotte, où mes connexions culturelles et mon réseau de prestataires sont particulièrement solides. Chaque demande internationale est étudiée individuellement lors de l'appel découverte.",
    cta: null,
  },
];

function ServiceAccordionItem({ svc, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-testid={`service-item-${index}`}
      style={{
        borderTop: "1px solid rgba(61,22,2,0.12)",
        ...(index === services.length - 1 ? { borderBottom: "1px solid rgba(61,22,2,0.12)" } : {}),
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "32px 0",
          background: "none",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
          gap: "24px",
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", gap: "20px", flex: 1 }}>
          <span style={{ fontSize: "10px", letterSpacing: "3px", color: "rgba(61,22,2,0.35)", fontFamily: "'Inter', sans-serif", minWidth: "24px", flexShrink: 0 }}>
            {svc.num}
          </span>
          <div>
            <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "clamp(20px, 3vw, 28px)", fontWeight: 300, color: "#3D1602", margin: 0, letterSpacing: "0.05em", lineHeight: 1.2 }}>
              {svc.name}
            </p>
            <p style={{ fontSize: "10px", letterSpacing: "3px", textTransform: "uppercase", color: "#6D5E56", margin: "6px 0 0", fontFamily: "'Inter', sans-serif", fontWeight: 400 }}>
              {svc.type}
            </p>
          </div>
        </div>
        <div style={{ width: "32px", height: "32px", border: "1px solid rgba(61,22,2,0.2)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all 0.35s ease", backgroundColor: open ? "#3D1602" : "transparent" }}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ transition: "transform 0.35s ease", transform: open ? "rotate(45deg)" : "rotate(0deg)" }}>
            <line x1="6" y1="0" x2="6" y2="12" stroke={open ? "#F7F3EA" : "#3D1602"} strokeWidth="1" />
            <line x1="0" y1="6" x2="12" y2="6" stroke={open ? "#F7F3EA" : "#3D1602"} strokeWidth="1" />
          </svg>
        </div>
      </button>

      <div style={{ overflow: "hidden", maxHeight: open ? "300px" : "0", transition: "max-height 0.45s cubic-bezier(0.4, 0, 0.2, 1)" }}>
        <div style={{ paddingBottom: "36px", paddingLeft: "44px" }}>
          <p style={{ fontSize: "14px", lineHeight: "1.9", color: "#6D5E56", fontWeight: 300, marginBottom: "28px", maxWidth: "480px" }}>
            {svc.desc}
          </p>
          <Link to="/prestations" style={{ fontSize: "10px", letterSpacing: "3px", textTransform: "uppercase", color: "#3D1602", textDecoration: "none", borderBottom: "1px solid rgba(61,22,2,0.4)", paddingBottom: "2px", fontFamily: "'Inter', sans-serif", fontWeight: 400 }}>
            En savoir plus
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  useScrollReveal();

  return (
    <main className="page-fade" data-testid="home-page">

      {/* ── HERO ── */}
      <section
        data-testid="hero-section"
        style={{
          position: "relative",
          height: "100vh",
          minHeight: "700px",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={HERO_IMG}
          alt="Mariage élégant"
          style={{
            position: "absolute", inset: 0,
            width: "100%", height: "100%",
            objectFit: "cover", objectPosition: "center",
          }}
        />
        {/* Warm dark overlay */}
        <div style={{
          position: "absolute", inset: 0,
          backgroundColor: "rgba(30, 10, 2, 0.52)",
        }} />

        {/* Hero content */}
        <div style={{
          position: "relative", zIndex: 2,
          textAlign: "center",
          padding: "0 24px",
          maxWidth: "800px",
        }}>
          <div className="hero-reveal">
            <img src={LOGO_WHITE} alt="ELLAA WEDDING" style={{ height: "330px", margin: "0 auto 36px", display: "block", filter: "brightness(0) saturate(100%) invert(97%) sepia(8%) saturate(400%) hue-rotate(330deg) brightness(99%) contrast(92%)" }} />
          </div>

          <div className="hero-reveal delay-1">
            <div style={{ width: "40px", height: "1px", backgroundColor: "rgba(233,220,196,0.4)", margin: "0 auto 28px" }} />
          </div>

          <div className="hero-reveal delay-2">
            <p style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
              fontSize: "clamp(2rem, 5vw, 3.5rem)",
              color: "#E9DCC4",
              margin: "0 0 20px",
              lineHeight: 1.3,
            }}>
              L'amour orchestré avec précision.
            </p>
          </div>

          <div className="hero-reveal delay-3">
            <p style={{
              fontSize: "11px",
              letterSpacing: "4px",
              textTransform: "uppercase",
              color: "rgba(247,243,234,0.65)",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 300,
              marginBottom: "40px",
            }}>
              Wedding Planner · Mariages Multiculturels &amp; Afro-Caribéens
            </p>
          </div>

          <div className="hero-reveal delay-4">
            <a
              href="https://calendly.com/ellaa-wedding/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta"
              className="btn-outline"
            >
              Planifier un appel découverte
            </a>
          </div>
        </div>

        {/* Scroll indicator */}
        <div style={{
          position: "absolute", bottom: "32px", left: "50%",
          transform: "translateX(-50%)",
          display: "flex", flexDirection: "column", alignItems: "center", gap: "8px",
        }}>
          <div style={{ width: "1px", height: "40px", backgroundColor: "rgba(247,243,234,0.3)", position: "relative", overflow: "hidden" }}>
            <div style={{
              position: "absolute", top: 0, left: 0, width: "100%",
              height: "50%", backgroundColor: "rgba(247,243,234,0.7)",
              animation: "scrollLine 2s ease-in-out infinite",
            }} />
          </div>
        </div>
        <style>{`
          @keyframes scrollLine {
            0% { transform: translateY(-100%); }
            100% { transform: translateY(200%); }
          }
        `}</style>
      </section>

      {/* ── ABOUT PREVIEW ── */}
      <section
        data-testid="about-section"
        style={{ padding: "120px 24px", backgroundColor: "#F7F3EA" }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "40px",
            alignItems: "center",
          }}
            className="md:grid-cols-2"
          >
            {/* Text */}
            <div>
              <p className="scroll-reveal" style={{
                fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase",
                color: "#6D5E56", marginBottom: "24px"
              }}>
                La Wedding Planner
              </p>
              <h2 className="scroll-reveal delay-1" style={{
                fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
                fontSize: "clamp(2rem, 4vw, 3rem)",
                fontWeight: 300,
                color: "#3D1602",
                lineHeight: 1.2,
                marginBottom: "32px",
              }}>
                La wedding planner qui comprend votre histoire.
              </h2>
              <p className="scroll-reveal delay-2" style={{
                fontSize: "15px", lineHeight: "1.9", color: "#6D5E56",
                fontWeight: 300, marginBottom: "20px"
              }}>
                Je suis Laurine, fondatrice d'ELLAA WEDDING.
              </p>
              <p className="scroll-reveal delay-2" style={{
                fontSize: "15px", lineHeight: "1.9", color: "#6D5E56",
                fontWeight: 300, marginBottom: "20px"
              }}>
                J'accompagne les couples dans la création de mariages élégants, profondément personnels et porteurs de sens.
              </p>
              <p className="scroll-reveal delay-2" style={{
                fontSize: "15px", lineHeight: "1.9", color: "#6D5E56",
                fontWeight: 300, marginBottom: "20px"
              }}>
                Chaque mariage est une histoire unique, une vision, une émotion à traduire avec justesse. Mon rôle est de donner vie à cette vision en créant une expérience fluide, harmonieuse et parfaitement maîtrisée.
              </p>
              <p className="scroll-reveal delay-2" style={{
                fontSize: "15px", lineHeight: "1.9", color: "#6D5E56",
                fontWeight: 300, marginBottom: "20px"
              }}>
                Mon approche est celle d'une véritable cheffe d'orchestre. J'anticipe chaque détail, je coordonne chaque intervenant et j'harmonise chaque moment pour que tout s'enchaîne avec évidence.
              </p>
              <p className="scroll-reveal delay-2" style={{
                fontSize: "15px", lineHeight: "1.9", color: "#6D5E56",
                fontWeight: 300, fontStyle: "italic", marginBottom: "40px"
              }}>
                Pour que, le jour J, vous puissiez vous laisser porter… et vivre pleinement chaque instant de votre mariage, comme une symphonie parfaitement orchestrée.
              </p>
              <div className="scroll-reveal delay-3">
                <Link to="/a-propos" className="btn-outline-dark" data-testid="about-link">
                  Découvrir mon histoire
                </Link>
              </div>
            </div>

            {/* Photo */}
            <div className="scroll-reveal delay-1 img-hover">
              <div style={{ maxWidth: "480px", margin: "0 auto" }}>
                <img
                  src={LAURINE_PHOTO}
                  alt="Laurine — ELLAA WEDDING"
                  style={{
                    width: "100%",
                    height: "580px",
                    objectFit: "cover",
                    objectPosition: "center top",
                    display: "block",
                  }}
                />
                <div style={{ paddingTop: "20px", textAlign: "left" }}>
                  <p style={{
                    fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
                    fontSize: "22px",
                    fontWeight: 300,
                    color: "#3D1602",
                    margin: 0,
                    letterSpacing: "0.5px",
                  }}>Laurine</p>
                  <p style={{
                    fontSize: "10px",
                    letterSpacing: "4px",
                    textTransform: "uppercase",
                    color: "#6D5E56",
                    marginTop: "6px",
                  }}>Fondatrice</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── MAESTRA METHOD ── */}
      <section
        data-testid="maestra-section"
        style={{ padding: "120px 24px", backgroundColor: "#F7F3EA", borderTop: "1px solid rgba(61,22,2,0.07)" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "80px" }}>
            <p className="scroll-reveal" style={{
              fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase",
              color: "rgba(61,22,2,0.4)", marginBottom: "20px"
            }}>
              Notre approche
            </p>
            <h2 className="scroll-reveal delay-1" style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
              fontSize: "clamp(2.5rem, 5vw, 4rem)",
              fontWeight: 300,
              color: "#3D1602",
              marginBottom: "16px",
              letterSpacing: "-0.02em",
            }}>
              La méthode MAESTRA
            </h2>
            <p className="scroll-reveal delay-2" style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
              fontSize: "22px",
              color: "rgba(61,22,2,0.4)",
            }}>
              Chaque mariage orchestré comme une symphonie.
            </p>
          </div>

          {/* 7 MAESTRA cards */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "2px",
          }}
            className="md:grid-cols-4"
          >
            {maestra.map((item, i) => (
              <div
                key={i}
                className={`scroll-reveal delay-${Math.min(i + 1, 6)}`}
                style={{
                  padding: "40px 28px",
                  border: "1px solid rgba(61,22,2,0.08)",
                  backgroundColor: i === 6 ? "rgba(61,22,2,0.02)" : "transparent",
                  gridColumn: i === 6 ? "span 2" : "span 1",
                  transition: "background-color 0.4s ease",
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = "rgba(61,22,2,0.04)"}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = i === 6 ? "rgba(61,22,2,0.02)" : "transparent"}
              >
                <div style={{
                  fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
                  fontSize: "60px",
                  color: "rgba(61,22,2,0.15)",
                  lineHeight: 1,
                  marginBottom: "16px",
                }}>
                  {item.letter}
                </div>
                <p style={{
                  fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#3D1602",
                  marginBottom: "12px",
                  letterSpacing: "1px",
                }}>
                  {item.name}
                </p>
                <p style={{
                  fontSize: "13px",
                  lineHeight: "1.8",
                  color: "rgba(61,22,2,0.55)",
                  fontWeight: 300,
                }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section
        data-testid="services-section"
        style={{ padding: "120px 24px", backgroundColor: "#F7F3EA" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>

          {/* Header */}
          <div style={{ marginBottom: "72px" }}>
            <p className="scroll-reveal" style={{
              fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase",
              color: "#6D5E56", marginBottom: "20px"
            }}>
              Nos prestations
            </p>
            <h2 className="scroll-reveal delay-1" style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
              fontSize: "clamp(1.1rem, 3.5vw, 3.5rem)",
              fontWeight: 300,
              color: "#3D1602",
              letterSpacing: "-0.02em",
              maxWidth: "none",
              whiteSpace: "nowrap",
            }}>
              Quatre formules, une seule promesse.
            </h2>
          </div>

          {/* Two-column layout: Accordion left, Image right */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "64px",
            alignItems: "start",
          }}
            className="services-grid"
          >
            {/* Left: Accordion */}
            <div className="scroll-reveal delay-1" data-testid="services-accordion-col">
              {services.map((svc, i) => (
                <ServiceAccordionItem key={i} svc={svc} index={i} />
              ))}
            </div>

            {/* Right: Image fixe */}
            <div
              className="scroll-reveal delay-2 services-image-col"
              data-testid="services-image-col"
              style={{ position: "sticky", top: "120px" }}
            >
              <div style={{ position: "relative", overflow: "hidden" }}>
                <img
                  src={SERVICES_IMG}
                  alt="Mariage élégant ELLAA WEDDING"
                  style={{ width: "100%", height: "680px", objectFit: "cover", objectPosition: "center", display: "block" }}
                />
                <div style={{ position: "absolute", bottom: "28px", left: "28px", right: "28px" }}>
                  <div style={{ backgroundColor: "rgba(247,243,234,0.88)", backdropFilter: "blur(8px)", padding: "20px 24px", display: "inline-block" }}>
                    <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "20px", color: "#3D1602", margin: 0, lineHeight: 1.3 }}>
                      L'amour orchestré avec précision.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="scroll-reveal delay-3" style={{ marginTop: "64px", textAlign: "center" }}>
            <Link
              to="/prestations"
              className="btn-outline-dark"
              data-testid="services-cta"
            >
              Découvrir toutes nos formules
            </Link>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section
        data-testid="faq-section"
        style={{ padding: "120px 24px", backgroundColor: "#F7F3EA" }}
      >
        <div style={{ maxWidth: "780px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "72px" }}>
            <p className="scroll-reveal" style={{
              fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase",
              color: "#6D5E56", marginBottom: "20px"
            }}>
              Questions fréquentes
            </p>
            <h2 className="scroll-reveal delay-1" style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: 300, color: "#3D1602",
              letterSpacing: "-0.02em",
            }}>
              Tout ce que vous souhaitez savoir.
            </h2>
          </div>

          <div className="scroll-reveal delay-2">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  style={{ borderColor: "rgba(61,22,2,0.12)" }}
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#3D1602",
                      textAlign: "left",
                      letterSpacing: "0.2px",
                      textDecoration: "none",
                      gap: "16px",
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "baseline", gap: "16px" }}>
                      <span style={{ fontSize: "10px", letterSpacing: "3px", color: "rgba(61,22,2,0.35)", flexShrink: 0 }}>
                        0{i + 1}
                      </span>
                      {faq.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.9",
                      color: "#6D5E56",
                      fontWeight: 300,
                      paddingTop: "4px",
                      paddingLeft: "26px",
                    }}
                  >
                    <p style={{ marginBottom: faq.cta ? "20px" : "0" }}>{faq.a}</p>
                    {faq.cta && (
                      <a
                        href={faq.cta.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "11px",
                          letterSpacing: "2px",
                          textTransform: "uppercase",
                          color: "#3D1602",
                          textDecoration: "none",
                          borderBottom: "1px solid rgba(61,22,2,0.4)",
                          paddingBottom: "2px",
                          fontFamily: "'Inter', sans-serif",
                          fontWeight: 400,
                        }}
                      >
                        → {faq.cta.label}
                      </a>
                    )}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* Phrase de clôture */}
            <p className="scroll-reveal delay-3" style={{
              marginTop: "56px",
              textAlign: "center",
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
              fontSize: "26px",
              color: "rgba(61,22,2,0.5)",
              fontStyle: "italic",
            }}>
              Vous avez d'autres questions ? Je suis là.
            </p>
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      <section
        data-testid="cta-section"
        style={{
          padding: "140px 24px",
          textAlign: "center",
          backgroundColor: "#F7F3EA",
          borderTop: "1px solid rgba(61,22,2,0.07)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div style={{ position: "relative", zIndex: 1, maxWidth: "700px", margin: "0 auto" }}>
          <p className="scroll-reveal" style={{
            fontSize: "10px", letterSpacing: "5px", textTransform: "uppercase",
            color: "rgba(61,22,2,0.4)", marginBottom: "24px"
          }}>
            Commençons ensemble
          </p>
          <h2 className="scroll-reveal delay-1" style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
            fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
            fontWeight: 300,
            color: "#3D1602",
            marginBottom: "16px",
            letterSpacing: "-0.02em",
            lineHeight: 1.1,
          }}>
            La saison est ouverte.
          </h2>
          <p className="scroll-reveal delay-2" style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
            fontSize: "24px",
            color: "rgba(61,22,2,0.5)",
            marginBottom: "40px",
          }}>
            Écrivons ensemble le mariage qui vous ressemble.
          </p>
          <div className="scroll-reveal delay-3">
            <a
              href="https://calendly.com/ellaa-wedding/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-button"
              className="btn-primary"
            >
              Planifier un appel découverte
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
